import {useMemo} from 'react';

import MoLoveAnimation from '@assets/animations/Mo-Love.json';
import PaymentLinkLoaderAnimation from '@assets/animations/PaymentLinkLoader.json';
import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';
import {useSearchParams} from 'react-router-dom';

import PoweredByModak from '@/app/shared-components/PoweredByModak/PoweredByModak';

import '../../styles';
import './styles';

import {PAYMENT_LINK_V2_QUERY_PARAMS} from '../../models/constants/constants';

export const PaymentLinkV2Skeleton = () => {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();

  const isFundRaise = useMemo(
    () => searchParams.get(PAYMENT_LINK_V2_QUERY_PARAMS.FUND_RAISE) !== null,
    [searchParams],
  );

  return (
    <section className="payment-link-v2-background">
      <Box className="payment-link-v2-container payment-link-v2-skeleton">
        <PoweredByModak />
        {isFundRaise ? (
          <Box className="payment-link-v2-skeleton__fundraise-text">
            <Typography className="payment-link-v2-skeleton__title-text">
              {t('payment_link.loading_fundraiser_title')}
            </Typography>
            <Typography className="payment-link-v2-skeleton__subtitle">
              {t('payment_link.loading_fundraiser_subtitle')}
            </Typography>
          </Box>
        ) : (
          <Typography className="payment-link-v2-skeleton__title">
            {t('payment_link.loading')}
          </Typography>
        )}
        <Box className="payment-link-v2-skeleton__lottie">
          <Lottie
            animationData={
              isFundRaise ? MoLoveAnimation : PaymentLinkLoaderAnimation
            }
            loop
            style={{width: 225, height: 225}}
          />
        </Box>
      </Box>
    </section>
  );
};
